import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Button } from "@mui/material";
import { RefreshOutlined } from "@mui/icons-material";
import BackupRoundedIcon from "@mui/icons-material/BackupRounded";
import AddJobModal from "./AddJobModal";
import CombinedJob from "./CombinedJob";

const useStyle = makeStyles((theme) => ({
  gridRow: {
    marginBottom: theme.spacing(3),
  },
  button: {},
}));

const ModalGrid = ({
  source,
  setRefresh,
  formOptions,
  formFields,
  combined,
  schedule,
  submitButton,
}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyle();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.gridRow}
      >
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          className={classes.button}
          startIcon={<BackupRoundedIcon />}
        >
          {schedule
            ? `Schedule ${source.name}`
            : combined
            ? `Start ${source.name}`
            : "Start"}
        </Button>
        <Button
          variant="outlined"
          className={classes.button}
          onClick={() => {
            setRefresh((prevValue) => !prevValue);
          }}
        >
          <RefreshOutlined />
        </Button>

        {combined ? (
          <CombinedJob
            open={open}
            handleClose={handleClose}
            formOptions={formOptions}
            source={source}
            setRefresh={setRefresh}
            formFields={formFields}
            submitButton={submitButton}
          />
        ) : (
          // SINGLE JOB .... NOT IN USE CURRENTLY
          <AddJobModal
            open={open}
            handleClose={handleClose}
            source={source}
            formOptions={formOptions}
            submitButton={submitButton}
          />
        )}
      </Grid>
    </>
  );
};

export default ModalGrid;
